<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row>
        <b-col md="6" sm="12" class="mt-2 pb-4">
          <p class="reg-heading-tab">SHG Details</p>
          <p></p>
          <div class="reg-tab-container">

            <b-form-group
              id="GrpName"
              horizontal
              label="SHG Name*"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                id="ipGrpname"
                type="text"
                required
                size="sm"
                placeholder="SHG Name"
                v-model="form.GroupName"
                :formatter="format"
                lazy-formatter
              ></b-form-input>
            </b-form-group>
          
            
            <b-form-group
              id="grpAdrs"
              label="Registered Address*"
              label-size="sm"
              label-for="ipadrs"
            >
              <b-form-input
                id="ipadrs"
                type="text"
                :formatter="format"
                lazy-formatter
                size="sm"
                v-model="form.GroupRegisteredAddress"
                placeholder="Address"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="members"
              label="Total No of Members*"
              label-size="sm"
              label-for="member"
            >
              <b-form-input
                id="member"
                type="number"
                :formatter="format"
                lazy-formatter
                size="sm"
                v-model="form.CompanyRegNo"
                required
                placeholder="Total No of Members"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="ObcWomen"
              label="Total No of OBC womens*"
              label-size="sm"
              label-for="obc"
            >
              <b-form-input
                id="obc"
                type="number"
                :formatter="format"
                lazy-formatter
                size="sm"
                v-model="form.CompanyType"
                placeholder="Total No of OBC womens"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Name of SHG Head*"
              label-size="sm"
              label-for="exampleInput4"
            >
              <b-form-input
                id="exampleInput4"
                type="text"
                :formatter="format"
                lazy-formatter
                v-model="form.NameofSHGHead"
                required
                size="sm"
                placeholder="Name of SHG Head"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="PAN"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.GroupPAN"
                placeholder="PAN 10 digit"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="6" sm="12" class="mt-2">
          <p>
            <span class="reg-heading-tab">SHG Bank Details</span>
          </p>

          <div class="reg-tab-container">
            <p style="colour:red" class="m-2" >Bank Account Details should be provided (only Nationalised Banks)</p>
            <!-- <b-form-group
              id="exampleInputGroup_ac_name"
              horizontal
              label="SHG Bank Account Name (Name as per the bank record)*"
              label-size="sm"
              label-for="inpbankName_acname"
            >
              <b-form-input
                id="inpbankName_acname"
                type="text"
                v-model="form.BankAccountNo"
                size="sm"
                required
                placeholder="Bank Account Name"
                
              ></b-form-input>
            </b-form-group> -->
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Bank Account Number*"
              label-size="sm"
              label-for="inpbankName"
            >
              <b-form-input
                id="inpbankName"
                type="text"
                v-model="form.BankAccountNo"
                size="sm"
                required
                placeholder="Bank Account No"
                
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Bank IFSC Code*"
              label-size="sm"
              label-for="inpbranchName"
            >
              <b-form-input
                id="inpbranchName"
                type="text"
                v-model="form.BankIfscCode"
                size="sm"
                required
                placeholder="Bank IFSC Code"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Bank Name*"
              label-size="sm"
              label-for="inpBankName"
            >
              <b-form-input
                id="inpBankName"
                type="text"
                v-model="form.BankName"
                size="sm"
                required
                placeholder="Bank Name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Branch Name*"
              label-size="sm"
              label-for="inpBranchName"
            >
              <b-form-input
                id="inpBranchName"
                type="text"
                v-model="form.BranchName"
                size="sm"
                required
                placeholder="Branch Name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="City*"
              label-size="sm"
              label-for="inpCity"
            >
              <b-form-input
                id="inpCity"
                type="text"
                v-model="form.City"
                size="sm"
                required
                placeholder="City"
              ></b-form-input>
            </b-form-group>
            <!--<b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Business Name*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.BusinessName"
                placeholder="Business Name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Business Address*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.BusinessAddress"
                placeholder="Business Address"
              ></b-form-input>
            </b-form-group>-->
            <!-- <b-form-group
                      id="exampleInputGroup1"
                      horizontal
                      label="State"
                      label-size="sm"
                      label-for="exampleInput1"
                    >
                      <b-form-select
                        id="exampleInput1"
                        :options="states"
                        value-field="StateID"
                        text-field="StateName"
                        required
                        size="sm"
                        @change.native="filterDistricts"
                        v-model="form.CorrespondenceAddress.StateID"
                      ></b-form-select>
            </b-form-group>-->
            <!--<b-form-group
              id="exampleInputGroup2"
              horizontal
              label="District*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-select
                id="exampleInput2"
                :options="districts"
                value-field="DistID"
                text-field="DistName"
                required
                size="sm"
                @change.native="filterTalukas"
                v-model="form.District"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Taluka*"
              label-size="sm"
              label-for="exampleInput3"
            >
              <b-form-select
                id="exampleInput3"
                :options="talukas"
                value-field="TalukaID"
                text-field="TalukaName"
                required
                size="sm"
                v-model="form.Taluka"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="business-Sector"
              horizontal
              label="Business Sector*"
              label-size="sm"
              label-for="business-Sector-input"
            >
              <b-form-select
                id="business-Sector-input"
                :options="busineSectors"
                required
                size="sm"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Business Description*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-textarea
                type="textarea"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.FinalProduct"
                placeholder="Final Product"
                rows="3"
      max-rows="6"
              ></b-form-textarea>
            </b-form-group>-->
            
            
            <!-- <b-form-group
              id="grpBank"
              horizontal
              label="Bank Name*"
              label-size="sm"
              label-for="inpbankName"
            > -->
              <!-- <b-form-select
                id="inpbankName"
                :options="Banks"
                value-field="BankName"
                text-field="BankName"
                required
                size="sm"
                @change.native="filterBranches"
                v-model="form.BankName"
              ></b-form-select> 
            </b-form-group>-->
            <!-- <b-form-group id="grpBranch" label="Branch Name*" label-size="sm" label-for="inpBranch">
              <b-form-input
                id="inpBranch"
                type="text"
                v-model="form.Branch"
                required
                size="sm"
                placeholder="Branch Name"
              ></b-form-input>
            </b-form-group> -->
          </div>
        </b-col>
         
      </b-row>

      <b-row class="mt-2" v-if="!form.LockProfile">
        <b-col style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col style="text-align:right" class="button-wrap">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <component :is="selected" v-on:click="show=!show" ></component>
        </b-col>
      </b-row>
    </b-form>
    <br />
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import AddressDetails from './AddressDetails.vue';
export default {
  name: "PersonalDetails",
  components: { Spinner, DatePicker,AddressDetails },
  //props:["OBCMembers"],
  data() {
    return {
      show:false,
      selected : 'AddressDetails',
      DOB: null,
      form: {
        GroupID: "00000000-0000-0000-0000-000000000000",
        UserID: "00000000-0000-0000-0000-000000000000",
        GroupName: "",
        CompanyRegNo: "0",
        CompanyType: "0",
        IsUnderDisability: false,
        GroupTAN: "",
        GroupPAN: "",
        GroupRegisteredAddress: "",
        BusinessName: "",
        BusinessAddress: "",
        District: "",
        Taluka: "",
        FinalProduct: "",
        LoanAmount: 0,
        LoanDistrict: "",
        BankName: "",
        Branch: "",
        BankAccountNo: "",
        BankIfscCode: "",
        BankName: "",
        BranchName: "",
        City: "",
        UserID: "",
        TotalMembers:0,
        TotalObc:0
      },
      Banks: [],
      CompanyTypes: [],
      CompanyTypeOption: [
        {
          ID: "Government Approved Saving Group",
          RelationshipName: "Government Approved Saving Group"
        },
        {
          ID: "Partnerships",
          RelationshipName:
            "Partnerships (Approved by Registrar of Firms, Maharashtra State, Mumbai)"
        },
        {
          ID: "Co-Operative Firms",
          RelationshipName:
            "Co-Operative Firms (Approved by District Sub-Registrar)"
        },
        {
          ID: "Company/LLP/Society",
          RelationshipName:
            "Company/LLP/Society (As mentioned on webportal of Company Act 2013)"
        },
        {
          ID: "FPO",
          RelationshipName: "Farm Produce Organization (FPO)"
        },
        {
          ID: "SHG",
          RelationshipName: "Self Help Group (SHG)"
        }
      ],
      districts: [],
      talukas: [],
      busineSectors: [
          { value: '1', text: 'Agriculture, allied and traditional activities' },
          { value: '2', text: 'Small scale industries and Medium scale industries' },
          { value: '3', text: 'Service Sector'},
        ],
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      saved: false
    };
  },
  computed: {
    
    getUserData() {
      let x = this.$store.getters.getUserData;
      let OrganizationName = "";
      let ProductfromOrganization = "";
      let OrganizationAddress = "";
      let AmountFromBank = 0;

      return {
        LockProfile: x.LockProfile
      };
    },
    validatePan() {
      if (this.form.GroupPAN == null) {
        return false;
      }

      if (this.form.GroupPAN.length == 0) {
        return false;
      } else if (this.form.GroupPAN != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.form.GroupPAN.match(panformat)) {
          return true;
        } else {
          return false;
        }
        //PAN 5th letter should match Surname's first l
        //Kuldip Removed this condition as Married woman face problem
        // if (
        //   this.form.PanCardNo.match(panformat) &&
        //   this.form.PanCardNo.charAt(4).toLowerCase() ==
        //     this.form.LastName.charAt(0).toLowerCase()
        // ) {
        //   return true;
        // } else {
        //   return false;
        // }
        //return true;
      } else {
        return false;
      }
    },
    validateTan() {
      if (this.form.GroupTAN == null) {
        return true;
      }

      if (this.form.GroupTAN.length == 0) {
        return false;
      } else if (this.form.GroupTAN != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.form.GroupTAN.match(panformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // validateMembers(){
    //   if(this.OBCMembers){
    //     if(!TotalObc<total50){
    //       return false;
    //     }else{
    //       return true;
    //     }
    //   }
    // }
  },
  filterBranches(evt) {
      let id = evt.target.value;
      this.getBranches(id);
    },
  methods: {
    setSelected(tab){
            this.selected = tab;
        },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    format(value, event) {
      if (value ) {
        return value.trim();
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    convertDateFormat(indate) {
      return indate.split("T")[0];
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;
      this.saved = false;

      // if (!this.validatePan) {

      //   this.alertText = "Please verify the PAN";
      //   this.variant = "warning";
      //   this.showDismissibleAlert = true;
      //   this.isLoading = false;
      //   return;
      // }
      if (!this.form.BankAccountNo) {
        this.alertText = "Please enter the Bank Account No)";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.form.BankIfscCode) {
        this.alertText = "Please enter the Bank IFSC Code)";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.form.BankName) {
        this.alertText = "Please enter the Bank Name)";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.form.BranchName) {
        this.alertText = "Please enter the Branch Name)";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      var total50=this.form.TotalMembers/2;
      total50=parseInt(total50);

     
      if(this.form.TotalObc<total50){
        this.alertText = "According to the Government Resolution, 50% of the total Self-Help Group (SHG) members must be women from Other Backward Classes (OBC)";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      // if (!this.validateMembers) {
      //   this.alertText = "OBC Members should be 50% of total members";
      //   this.variant = "warning";
      //   this.showDismissibleAlert = true;
      //   this.isLoading = false;
      //   return;
      // }


      // if (!this.validateTan) {
      //   this.alertText = "Please verify the TAN";
      //   this.variant = "warning";
      //   this.showDismissibleAlert = true;
      //   this.isLoading = false;
      //   return;
      // }

      var userinfo = this.$store.getters.loggedUser;
      this.form.UserID = userinfo.UserId;

      let promise = apis.saveGroup(this.form);
      //this.$store.dispatch("setUserData", this.form);
      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.form = response.body;
            this.$store.dispatch("setGroupID", this.form.GroupID);
            this.$store.dispatch("setLoanDistrict", this.form.LoanDistrict);
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.saved = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error while saving data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

         let promise1 = apis.SaveBankAccount(this.form);

      promise1
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.isSaved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form = {
        GroupID: "",
        UserID: "",
        GroupName: "",
        CompanyRegNo: "",
        CompanyType: "",
        IsUnderDisability: false,
        GroupTAN: "",
        GroupPAN: "",
        GroupRegisteredAddress: "",
        BusinessName: "",
        BusinessAddress: "",
        District: "",
        Taluka: "",
        FinalProduct: "",
        LoanAmount: 0,
        LoanDistrict: ""
      };
    },
    filterDistricts(evt) {
      let id = evt.target.value;
      this.getDistricts(id);
    },
    getUserBankDetails() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.getUserBankDetails(userinfo.UserId);

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.form = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    // filterTalukas(evt) {
    //   let id = evt.target.value;
    //   this.form.LoanDistrict = id;
    //   let district = _.filter(this.districts, { DistID: id });
    //   if (district) {
    //     this.$store.dispatch("setLocation", district[0].DistName);
    //   }
    //   this.getTalukas(id);
    // },

    // getTalukas(districtId) {
    //   if (this.districts.length > 0) {
    //     let district = _.filter(this.districts, { DistID: districtId });
    //     if (district) {
    //       this.$store.dispatch("setLocation", district[0].DistName);
    //     }
    //   }
    //   let promise = apis.getTaluka(districtId);

    //   promise
    //     .then(response => {
    //       //console.log('Reponse' ,response);
    //       if (response.status == 200) {
    //         this.talukas = response.body;
    //         this.isLoading = false;
    //         //this.$router.push("/");
    //       } else {
    //         this.alertText = response.body;

    //         this.variant = "warning";
    //         this.showDismissibleAlert = true;
    //       }
    //     })
    //     .catch(err => {
    //       this.alertText = err.message;
    //       this.showDismissibleAlert = true;
    //       this.variant = "danger";
    //     });
    // },

    getCompanyType() {
      let promise = apis.ReadCompanyTypes();

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.CompanyTypes = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then(response => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.Banks = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.getCompanyType();
    this.ReadBanks();
    var userinfo = this.$store.getters.loggedUser;
    if (this.$store.getters.isLoggedIn) {
      
      this.getUserBankDetails();

      let promiseU = apis.ReadGroup(userinfo.UserId);
      promiseU
        .then(response => {
          if (response.status == 200) {
            if (response.body.length > 0) {
              this.form = response.body[0];
              this.$store.dispatch("setGroupID", this.form.GroupID);
              this.$store.dispatch("setLoanDistrict", this.form.LoanDistrict);
              //this.getTalukas(this.form.District);
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  }
};
</script>

<style>
.form-group {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/GroupDetails.vue